"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFID = exports.FIDThresholds = void 0;

var _bindReporter = require("./lib/bindReporter.js");

var _getVisibilityWatcher = require("./lib/getVisibilityWatcher.js");

var _initMetric = require("./lib/initMetric.js");

var _observe = require("./lib/observe.js");

var _onHidden = require("./lib/onHidden.js");

var _runOnce = require("./lib/runOnce.js");

var _whenActivated = require("./lib/whenActivated.js");

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */
const FIDThresholds = exports.FIDThresholds = [100, 300];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */

const onFID = (onReport, opts = {}) => {
  (0, _whenActivated.whenActivated)(() => {
    const visibilityWatcher = (0, _getVisibilityWatcher.getVisibilityWatcher)();
    const metric = (0, _initMetric.initMetric)('FID'); // eslint-disable-next-line prefer-const

    let report;

    const handleEntry = entry => {
      // Only report if the page wasn't hidden prior to the first input.
      if (entry.startTime < visibilityWatcher.firstHiddenTime) {
        metric.value = entry.processingStart - entry.startTime;
        metric.entries.push(entry);
        report(true);
      }
    };

    const handleEntries = entries => {
      entries.forEach(handleEntry);
    };

    const po = (0, _observe.observe)('first-input', handleEntries);
    report = (0, _bindReporter.bindReporter)(onReport, metric, FIDThresholds, opts.reportAllChanges);

    if (po) {
      (0, _onHidden.onHidden)((0, _runOnce.runOnce)(() => {
        handleEntries(po.takeRecords());
        po.disconnect();
      }));
    }
  });
};

exports.onFID = onFID;